import {
  OpcoesRepositorioBaseComFiltragemDeLeitura,
  RepositorioBaseComFiltragemDeLeitura,
} from "@/http"
import { ResultadoApiGET } from "@/types/api"
import {
  CriarAtividadePlanejada,
  EditarAtividadePlanejada,
  AtividadePlanejada,
  AtividadePlanejadaSimples,
  ParametrosAtividadePlanejada,
} from "./eventos.modelo"
import { AxiosRequestHeaders } from "axios"

class AtividadesPlanejadasRepositorio extends RepositorioBaseComFiltragemDeLeitura {
  public constructor(
    opcoesRepositorio: OpcoesRepositorioBaseComFiltragemDeLeitura = {}
  ) {
    super({
      ...opcoesRepositorio,
      parametrosPadrao: {
        "ordenar-por": ["desc.ativo"],
      },
    })
  }

  // se possível evitar de utilizar a rota frontend e utilizar a não frontend
  public listarAtividadesPlanejadasFrontend = (
    params?: ParametrosAtividadePlanejada,
    headers: AxiosRequestHeaders = {}
  ): Promise<ResultadoApiGET<AtividadePlanejada>> =>
    this.instance.get("/api/frontend/atividades-planejadas", {
      params,
      headers,
    })

  public listarAtividadesPlanejadas = (
    params?: ParametrosAtividadePlanejada,
  ): Promise<ResultadoApiGET<AtividadePlanejadaSimples>> =>
    this.instance.get("/api/atividades-planejadas", {
      params,
    })

  public criarAtividadePlanejada = (
    params?: CriarAtividadePlanejada
  ): Promise<{ id: string }> =>
    this.instance.post("/api/atividades-planejadas", { ...params })

  public deletarAtividadePlanejada = (
    id?: string
  ): Promise<{ id: string }> =>
    this.instance.delete("/api/atividades-planejadas/" + id)

  public editarAtividadePlanejada = (
    id?: string,
    evento?: EditarAtividadePlanejada
  ): Promise<{ id: string }> =>
    this.instance.patch(`/api/atividades-planejadas/${id}`, evento)

  public importarAtividadesPlanejadas = (arquivo?: File): Promise<Blob> => {
    if (!arquivo) {
      return Promise.reject("Arquivo não informado")
    }

    const formData = new FormData()
    formData.append("arquivo", arquivo)

    return this.instance.post(
      "/api/importacoes/atividades-planejadas",
      formData,
      {
        responseType: "blob",
      }
    )
  }
}

export default AtividadesPlanejadasRepositorio
